"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgWind = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M22.3 17.295a1 1 0 11-1.42-1.41A3 3 0 1123 21h-9a1 1 0 010-2h9.004a1 1 0 10-.705-1.705zm1.58 14.82a1 1 0 111.42-1.41A1 1 0 1026 29H14a1 1 0 110-2h11.996a3 3 0 11-2.115 5.115zm6.556-11.677a1 1 0 11-1.412-1.416A3.5 3.5 0 1131.5 25H14a1 1 0 010-2h17.498a1.5 1.5 0 10-1.062-2.562z",
    id: "wind_svg__a"
  }));
};

var _default = SvgWind;
exports.default = _default;